import request from "../request";

export default {
	
	get(data) {
		return request.get("/option/get", data);
	},
	
	set(data) {
		return request.post("/option/set", data);
	},
	
};
